import { z } from "zod";

export const HealthResponseSchema = z.object({
  ok: z.literal(true),
  version: z.string(),
  db: z.enum(["ok", "error"]),
});
export type HealthResponse = z.infer<typeof HealthResponseSchema>;
